import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import classnames from 'classnames'

import OwnedData from './targetGroup/OwnedData'
import SharedTargetGroupHeader from './targetGroup/SharedTargetGroupHeader'
import SharedTargetGroupList from './targetGroup/SharedTargetGroupList'

const MapData = ({ uiStore, dataStore, t }) => {
  return (
    <div className={classnames({ 'map-data': true, loading: uiStore.isRefreshingData })}>
      <OwnedData />
      {
        uiStore.user.canShare
          ? ([
            <SharedTargetGroupHeader
              key='header'
              extraClasses={['shared-with-me']}
              name={t('TARGET_GROUP.SHARED_WITH_ME')}
              toggle='sharedTargetGroupsExpanded'
              badgeNumber={dataStore.sharedTargetGroups.length}
              visibility={{ visible: true }}
              extraConfig={{ sorting: { attr: 'name', dir: 'asc', is_owner: false } }}
            />,
            <SharedTargetGroupList key='shared-target-group-list' />
            ])
          : null
      }
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'dataStore')(observer(MapData)))
